import { useLocation, useParams } from "react-router-dom";
import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import LicenseService from "../../../services/LicensesService";
import { FormLicenseFeature } from "./FormLicenseFeature";
import { useEffect, useState } from "react";

export function EditLicenseFeature({ ...props }) {
   const { licenseFeatureId } = useParams();
   const { state } = useLocation();
   const [licenseFeature, setLicenseFeature] = useState(state);
   const [type, setFeature] = useState("");

   async function loadLicenseFeature(id) {
      const response = await LicenseService.getFeature(id);
      if (response.data) {
         setLicenseFeature(response.data);
      }
   }

   useEffect(() => {
      setFeature(licenseFeatureId ? "edicao" : "cadastro");
      loadLicenseFeature(licenseFeatureId);
   }, [state, licenseFeatureId]);

   return (
      <CadastroContainer>
         <FormLicenseFeature licenseFeature={licenseFeature} type={type} />
      </CadastroContainer>
   );
}